(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/popupbox/assets/javascripts/components/popupbox.js') >= 0) return;  svs.modules.push('/components/components/popupbox/assets/javascripts/components/popupbox.js');
"use strict";


((svs, React, ReactDOM, PropTypes) => {
  const ReactIcon = svs.ui.ReactIcon;
  class Popupbox extends React.Component {
    constructor(props) {
      super(props);
      this.CloseIconRender = this.CloseIconRender.bind(this);
      this.BackArrowRender = this.BackArrowRender.bind(this);
      this.CreatePortal = this.CreatePortal.bind(this);
      this.PopupBox = this.PopupBox.bind(this);
      if (Boolean(this.props.portal) && Boolean(this.props.portalParent)) {
        const createdElement = document.createElement('div');
        const attrClass = document.createAttribute('class');
        const attrId = document.createAttribute('id');
        attrClass.value = this.props.portal;
        attrId.value = this.props.portal;
        createdElement.setAttributeNode(attrClass);
        createdElement.setAttributeNode(attrId);
        document.getElementById(this.props.portalParent).prepend(createdElement);
        this.container = createdElement;
      }
    }
    componentWillUnmount() {
      document.getElementById(this.props.portalParent).removeChild(this.container);
    }
    animationClass() {
      let classNames = 'align-center f-content f-content-service padding-xs-1 padding-sm-2';
      if (!this.props.noAnimation) {
        classNames = "".concat(classNames, " animate animate-show animate-delay-1ms");
      }
      return classNames;
    }
    shouldShowBoxContentsAnimation() {
      let classNames = 'js-popupbox-main padding-xs-1 padding-sm-h-2';
      if (!this.props.noAnimation) {
        classNames = "".concat(classNames, " animate animate-show animate-delay-2ms");
      }
      return classNames;
    }
    shouldShowBoxContents(dataError, partialError, suppressErrors) {
      if (dataError && !partialError && !suppressErrors) {
        return false;
      }
      return true;
    }
    removePathBase(url) {
      let index;
      if (url) {
        index = url.indexOf('/');
        if (index === 0) {
          index = url.indexOf('/', 1);
          if (!~index) {
            return '/';
          }
        }
        return url.substring(index);
      }
      return url;
    }
    CloseIconRender(_ref) {
      let children = _ref.children;
      let href;
      const dataUrl = this.removePathBase(this.props.url);
      if (this.props.externalUrl) {
        href = this.props.externalUrl;
      } else {
        href = this.props.url;
      }
      return React.createElement("a", {
        className: "js-navigate",
        "data-url": dataUrl,
        href: href,
        onClick: this.props.onClose
      }, children);
    }
    BackArrowRender(_ref2) {
      let children = _ref2.children;
      const href = this.props.backUrl;
      const dataUrl = this.removePathBase(href);
      let className = 'js-navigate';
      if (this.props.backNavigation) {
        className = "".concat(className, "-back");
      }
      return React.createElement("a", {
        className: className,
        "data-url": dataUrl,
        href: href,
        onClick: this.props.onBack
      }, children);
    }
    CreatePortal(_ref3) {
      let children = _ref3.children;
      return ReactDOM.createPortal(children, this.container);
    }
    PopupBox() {
      return React.createElement("div", {
        className: "".concat(this.props.className, " bg-white margin-1 margin-lg-h-0 margin-lg-v-1 pop-up-box")
      }, React.createElement("div", {
        className: "".concat(this.animationClass(), " pop-up-box-header")
      }, !this.props.hideCloseIcon && React.createElement(this.CloseIconRender, null, React.createElement("button", {
        className: "icon-button right close-button",
        type: "button"
      }, React.createElement(ReactIcon, {
        icon: "close"
      }))), Boolean(this.props.backArrow) && React.createElement(this.BackArrowRender, null, React.createElement("button", {
        className: "icon-button back-arrow left",
        type: "button"
      }, React.createElement(ReactIcon, {
        icon: "arrow-left"
      }))), Boolean(this.props.title) && React.createElement("h2", null, this.props.title)), Boolean(this.props.partialError) && !this.props.suppressPartialErrorWarning && React.createElement("div", {
        className: "fc-white bg-opacity-80 padding-1 margin-xs-h-1 margin-sm-h-2 margin-top-1 margin-xs-bottom-1 margin-sm-bottom-2"
      }, React.createElement("i", {
        className: "icon icon-default icon-exclamation-sign icon-200 fc-white padding-xs-right-1"
      }), "Tyv\xE4rr erfar vi just nu tekniska problem. Denna sida \xE4r d\xE4rf\xF6r ofullst\xE4ndig. Ladda om sidan eller f\xF6rs\xF6k senare."), this.shouldShowBoxContents(this.props.dataError, this.props.partialError, this.props.suppressErrors) && React.createElement("div", {
        className: this.shouldShowBoxContentsAnimation()
      }, this.props.children));
    }
    render() {
      return React.createElement(React.Fragment, null, Boolean(this.props.portal) && Boolean(this.props.portalParent) ? React.createElement(this.CreatePortal, null, React.createElement(this.PopupBox, null, this.props.children)) : React.createElement(this.PopupBox, null, this.props.children));
    }
  }
  Popupbox.defaultProps = {
    backArrow: false,
    backUrl: '/',
    className: '',
    hideCloseIcon: false,
    noAnimation: false,
    portalParent: 'main-content',
    url: '/'
  };
  svs.components.Popupbox = Popupbox;
})(svs, React, ReactDOM, PropTypes);

 })(window);